import { css } from 'styled-components';
import type { TypeLayoutDetailed } from 'types/autogen/contentful';

const oneColumn = css`
    // 1:1
    grid-template-columns: repeat(1, minmax(0, 1fr));
`;
const twoColumns = css`
    // 1:2.1:2
    grid-template-columns: repeat(2, minmax(0, 1fr));
`;
const threeColumns = css`
    // 1:3.1:3.1:3
    grid-template-columns: repeat(3, minmax(0, 1fr));
`;
const fourColumns = css`
    // 1:4.1:4.1:4.1:4
    grid-template-columns: repeat(4, minmax(0, 1fr));
`;
const A = css`
    // 1:2(1:2.1:2).1:2
    grid-template-columns: repeat(2, minmax(0, 1fr));

    & > :nth-child(3n+1) {
        grid-row: span 2;
    }
`;
const B = css`
    // 1:2(1:2.1:2).1:2(1:2.1:2)
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-flow: dense;

    // item 1 and 2 repeating
    & > :nth-child(4n-3),
    & > :nth-child(4n-2) {
        grid-column: 1;
    }

    // item 3 and 4 repeating
    & > :nth-child(4n-1),
    & > :nth-child(4n-4) {
        grid-column: 2;
    }
`;
const C = css`
    // 1:2.1:4.1:4
    grid-template-columns: repeat(4, minmax(0, 1fr));

    & > :nth-child(3n+1) {
        grid-column: span 2;
    }
`;
const D = css`
    // 1:3(1:2.1:2).2:3
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-auto-flow: dense;

    & > :not(& > :nth-child(3n+3)) {
        grid-column: 1;
    }
    & > :nth-child(3n+3) {
        grid-column: span 2;
        grid-row: span 2;
    }
`;
const E = css`
    // 1:3.2:3
    grid-template-columns: repeat(3, minmax(0, 1fr));

    & > :nth-child(even) {
        grid-column: span 2;
    }
`;
const F = css`
    // 2:3.1:3
    grid-template-columns: repeat(3, minmax(0, 1fr));

    & > :nth-child(odd) {
        grid-column: span 2;
    }
`;
const G = css`
    // 2:3.1:3(1:2.1:2)
    grid-template-columns: repeat(3, minmax(0, 1fr));

    & > :nth-child(3n+1) {
        grid-column: span 2;
        grid-row: span 2;
    }
`;
const H = css`
    // 2:5.3:5
    grid-template-columns: repeat(5, minmax(0, 1fr));

    & > :nth-child(even) {
        grid-column: span 2;
    }

    & > :nth-child(odd) {
        grid-column: span 3;
    }
`;
const I = css`
    // 3:5.2:5
    grid-template-columns: repeat(5, minmax(0, 1fr));

    & > :nth-child(even) {
        grid-column: span 3;
    }

    & > :nth-child(odd) {
        grid-column: span 2;
    }
`;

export default function getDesktopLayout(layoutOnDesktop: TypeLayoutDetailed['fields']['layoutOnDesktop']) {
    switch (layoutOnDesktop) {
        case '1:1':
            return oneColumn;
        case '1:2.1:2':
            return twoColumns;
        case '1:3.1:3.1:3':
            return threeColumns;
        case '1:4.1:4.1:4.1:4':
            return fourColumns;
        case '1:2(1:2.1:2).1:2':
            return A;
        case '1:2(1:2.1:2).1:2(1:2.1:2)':
            return B;
        case '1:2.1:4.1:4':
            return C;
        case '1:3(1:2.1:2).2:3':
            return D;
        case '1:3.2:3':
            return E;
        case '2:3.1:3':
            return F;
        case '2:3.1:3(1:2.1:2)':
            return G;
        case '2:5.3:5':
            return H;
        case '3:5.2:5':
            return I;
        default:
            return oneColumn;
    }
}
